import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Header from "../Components/Header";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "../axiosInstance";
import Footer from "../Components/Footer";
import PageTitle from "../Components/PageTitle";
import AcademicExamTimeTable from "../assets/AcademicExamTimeTable.png";

const ExamTimeTable = () => {
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCalendarData = async () => {
      try {
        const response = await axios.get(
          "/api/v1/academic-exam-time-table/get"
        );
        setCalendarData(response?.data?.examTimeTable);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarData();
  }, []);

  const stripHtml = (html) => {
    const doc = new DOMParser()?.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Academic Exam Time Table - Shree Mangalam School"
        description="Check the latest academic exam time table for all classes at Shree Mangalam School. Stay informed about upcoming test dates and preparation schedules."
        url="/academic-exam-time-table"
        keywords="exam time table, academic schedule, school exam dates, Shree Manglam exam routine, RIMC exam timetable"
      />
      <Header
        image={AcademicExamTimeTable}
        alt={"Academic Exam Time Table Banner"}
      />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            fontSize: "30px",
            color: "#065A79",
            fontWeight: "bold",
            mb: 3,
          }}
          gutterBottom
        >
          Academic Exam Time Table
        </Typography>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <TableContainer component={Paper} elevation={3}>
            <Table sx={{ minWidth: 650 }} aria-label="academic calendar table">
              <TableHead sx={{ backgroundColor: "#065A79" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    Title
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "#fff",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                    }}
                  >
                    File
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {calendarData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        width: "8%",
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        // width: "30%",
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {item?.title}
                    </TableCell>

                    <TableCell
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {stripHtml(item?.desc)}
                    </TableCell>

                    {/* <TableCell
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                        cursor: "pointer",
                      }}
                    >
                      {item.url}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        fontFamily: "Montserrat, sans-serif",
                        fontOpticalSizing: "auto",
                        fontStyle: "normal",
                        letterSpacing: 1,
                      }}
                    >
                      {item?.url && (
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "#065A79",
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <DownloadIcon />
                        </a>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default ExamTimeTable;
